import React, { useEffect, useState, useRef } from "react";
import { FaSearch,  FaPhoneAlt } from "react-icons/fa";
import { BiSolidPhoneCall } from "react-icons/bi";
import { IoLogoWhatsapp } from "react-icons/io";
import { Link } from "react-router-dom";
import { useAuth } from "../../AuthContext"; // Import useAuth to get currentUser, role, and logout
import ProductArray from "../products/ProductArray";
import "./Navbar.css";
import { debounce } from "lodash";
import { FaLocationDot } from "react-icons/fa6";
import { HiBars3 } from "react-icons/hi2";
import { LiaTimesSolid } from "react-icons/lia";

const Navbar = () => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const { currentUser, role, logout } = useAuth();

  const navbarRef = useRef(null);

  // Toggle the mobile dropdown
  const toggleDropdown = () => setDropdownVisible((prev) => !prev);

  // Toggle the search input box
  const toggleSearch = () => setSearchVisible((prev) => !prev);

  // Update search results with debounce
  const updateSearchResults = debounce((input) => {
    if (input.trim()) {
      const allProducts = Object.values(ProductArray).flat();
      const filteredResults = allProducts.filter((product) =>
        product.name.toLowerCase().includes(input.toLowerCase())
      );
      setSearchResults(filteredResults);
    } else {
      setSearchResults([]);
    }
  }, 300);

  useEffect(() => {
    updateSearchResults(searchInput);
  }, [searchInput]);

  const handleSearchInput = (e) => {
    setSearchInput(e.target.value);
  };

  const handleProductClick = (product) => {
    console.log("Product clicked:", product);
    setSearchInput("");
    setSearchResults([]);
    setSearchVisible(false);
  };

  const handleDropdownItemClick = () => {
    setDropdownVisible(false); // Close dropdown on item click
  };

  // Close dropdown when clicking outside the navbar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setDropdownVisible(false);
        setSearchVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close dropdown on screen resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setDropdownVisible(false); // Ensure dropdown closes when the screen size increases
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="navbar" ref={navbarRef}>
      <header>
        <div className="logo">
          <img src="/images/logo1.png" alt="Logo" data-aos="fade-down" />
        </div>
        <ul className={`ul-list ${dropdownVisible ? "show" : ""}`}>
          <div className="menuu">Adcore Consulting</div>
          <Link to="/" onClick={handleDropdownItemClick}>
            <li>Home</li>
          </Link>
          <Link to="/products" onClick={handleDropdownItemClick}>
            <li>Catalog</li>
          </Link>
          <Link to="/about" onClick={handleDropdownItemClick}>
            <li>About Us</li>
          </Link>
          <Link to="/contact" onClick={handleDropdownItemClick}>
            <li>Contact</li>
          </Link>
          <Link to="/service" onClick={handleDropdownItemClick}>
            <li>Services</li>
          </Link>

          {currentUser ? (
            <>
              <Link
                to={role === "admin" ? "/admin-dashboard" : "/user-dashboard"}
                onClick={handleDropdownItemClick}
                className="nav-auth"
              >
                Dashboard
              </Link>
              <li onClick={logout} className="nav-auth logout">
                Logout
              </li>
            </>
          ) : (
            <Link to="/login" className="nav-auth" onClick={handleDropdownItemClick}>
              Login
            </Link>
          )}

          <div>
            <h4>Contact Info</h4>
            <p>
              <span>
                <FaLocationDot />
              </span>
              12, Alade Street, Shomolu, Lagos{" "}
            </p>
            <p>
              <span>
                <FaPhoneAlt />
              </span>{" "}
              +234 802 387 9629 <br />
            </p>
          </div>
        </ul>

        <ul className="ul-icon">
          <li>
            <FaSearch onClick={toggleSearch} className="search-btn" />
          </li>
          <Link to="tel:+234-802-387-9629" className="call-icon">
            <BiSolidPhoneCall />
          </Link>
          <Link
            to="https://wa.me/2348023879629"
            className="whatsapp-icon"
            style={{ color: "#5ee75e", fontSize: "25px" }}
          >
            <IoLogoWhatsapp />
          </Link>
        </ul>

        <Link to={"/user-dashboard/user-chat"}>
          <h3 className="make-order">Make an order</h3>
        </Link>

        <button className="dropdown-btn" onClick={toggleDropdown} aria-label="Toggle menu">
          {dropdownVisible ? <LiaTimesSolid className="fatimes" />  :  <HiBars3 className="fabars"/>}
        </button>

        {searchVisible && (
          <div className="navbar-search">
            <div className="search-component">
              <input
                type="text"
                placeholder="Search for products here..."
                value={searchInput}
                onChange={handleSearchInput}
                aria-label="Search products"
              />
              <button className="search-button" aria-label="Search">
                <FaSearch />
              </button>
            </div>
            {searchResults.length > 0 && (
              <div className="search-results-dropdown">
                <ul>
                  {searchResults.map((product) => (
                    <li key={product.id} onClick={() => handleProductClick(product)}>
                      <Link to={`/search/${product.name.toLowerCase()}`}>
                        <img src={product.image} alt={product.name} />
                        <h5>{product.name}</h5>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
         {dropdownVisible && <div className="navbar-overlay" onClick={handleDropdownItemClick}></div>}
         
      </header>
    </div>
  );
};

export default Navbar;
